import React, { useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../../i18n';

// Compact language picker for the header. Shows the active language code and
// opens an MUI menu (matching the other header dropdowns) to switch. The choice
// is persisted to localStorage by i18next's language detector.
export const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const current = (i18n.resolvedLanguage || 'ro').slice(0, 2);

  const handleClose = () => setAnchorEl(null);

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    handleClose();
  };

  return (
    <div>
      <button
        type="button"
        className="link-button white bold text-uppercase"
        aria-label={t('language.switcherLabel')}
        aria-haspopup="true"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {current}
      </button>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {SUPPORTED_LANGUAGES.map(({ code, label }) => (
          <MenuItem
            key={code}
            selected={code === current}
            onClick={() => handleSelect(code)}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
